export default {
  title: 'Content/Table',
  tags: ['new'],
  argTypes: {
    striped: {
      control: 'select',
      options: ['none', 'even', 'odd'],
    },
    hover: {
      control: 'select',
      options: ['row', 'cell'],
    },
    columnHover: {
      control: 'boolean'
    },
    selectable: {
      control: 'boolean'
    },
    useRowHeader: {
      control: 'boolean'
    },
    overflow: {
      control: 'select',
      options: ['scroll', 'linearize'],
    },
    showToolbar: {
      control: 'boolean'
    },
    showCaption: {
      control: 'boolean'
    },
    liveRegion: {
      control: 'text',
    },
    context : {
      control: 'select',
      options: [ "light-inverts", "light-always", "dark-inverts", "dark-always"]
    },
    sx: {
      description: 'Supports adding inline styles as an object of key-value pairs comprised of CSS properties and values. Values should reference design tokens when possible.',
      control: 'object',
    },
  },
};


function generateTableHeaders(headers, selectable, context) {
  const checkbox = `
              <th>
                <cbp-checkbox ${context && context != 'light-inverts' ? `context="${context}"` : ''}>
                  <input type="checkbox" name="selectall" value="1">
                  <span style="display:none">Select Rows</span>
                </cbp-checkbox>
              </th>
  `
  let cells = headers.map( ({label, sortable, alignmentRight}, i)  => {
    return `
      ${ sortable ? `
              <th 
                ${i == 0 ? `aria-sort="ascending"` : ''}
                ${alignmentRight ? `style="text-align: right;"` : ''}
              >
                <cbp-button fill="ghost" color="secondary" name="${`column-${i}`}" value="${i}">
                  <cbp-icon></cbp-icon>${label}
                </cbp-button>
              </th>`
      : `
              <th
                ${alignmentRight ? `style="text-align: right;"` : ''}
              >
                ${label}
              </th>`
    }`;
  }).join('');

  if (selectable) cells = checkbox + cells;
  return `${cells}`;
}

function generateTableRows(data, useRowHeader, selectable, context) {
  const html = data.map( ({ row, danger }, i) => {
    const checkbox = `
            <td>
              <cbp-checkbox ${context && context != 'light-inverts' ? `context="${context}"` : ''}>
                <input type="checkbox" name="rowid" value="${i+1}">
                <span style="display:none">Select row ${i+1}</span>
              </cbp-checkbox>
            </td>
    `;

    let cells = row.map( ({td, danger, highlight, alignmentRight}, j)  => {
       return `
            ${useRowHeader && j==0 ? `<th` : `<td`}
              ${danger ? `class="cbp-table--danger"` : highlight ? `class="cbp-table--highlight"` : ``}
              ${alignmentRight ? `style="text-align: right;"` : ''}
            >${td}
            ${useRowHeader && j==0 ? `</th>` : `</td>`}
      `;
    }).join('');
    
    if (selectable) cells = checkbox + cells;
    
    return `
          <tr ${danger ? `class="cbp-table--danger"` :''}>
            ${cells}
          </tr>
    `;
  });
  return html.join('');
}


function toolbar() {
  return `
      <div slot="cbp-table-toolbar">
        <cbp-form-field sx='{"--cbp-form-field-margin-bottom":"0"}'>
          <cbp-form-field-wrapper>  
            <input
              type="search"
              name="tablesearch"
              placeholder="Filter Results"
            />
            <span slot="cbp-form-field-attached-button">
              <cbp-button
                type="submit"
                fill="solid"
                color="secondary"
                variant="square"
                accessibility-text="Search"
              >
                <cbp-icon name="magnifying-glass"></cbp-icon>
              </cbp-button>
            </span>
          </cbp-form-field-wrapper>
        </cbp-form-field>
      </div>
  `;
}


const Template = ({ tableData, headers, useRowHeader, selectable, striped, hover, columnHover, overflow, showToolbar, showCaption, liveRegion, context, sx }) => {
  
  return ` 
    <cbp-table
      ${striped != 'none' ? `striped="${striped}"` : ''}
      ${hover == 'cell' ? `hover="${hover}"` : ''}
      ${columnHover ? 'column-hover' : ''}
      ${overflow ? `overflow="${overflow}"` : ''}
      ${context && context != 'light-inverts' ? `context="${context}"` : ''}
      ${sx ? `sx='${JSON.stringify(sx)}'` : ''}
    >
      ${showToolbar ? toolbar() : ''}
      ${liveRegion ? `<div slot="cbp-table-live-region">${liveRegion}</div>` : ''}

      <table style="width:100%">
        <caption ${ showCaption ? '' : 'hidden' }>Table Caption</caption>
        <thead>
          <tr>
            ${generateTableHeaders(headers, selectable, context)}
          </tr>
        </thead>
        <tbody>
          ${generateTableRows(tableData, useRowHeader, selectable, context)}
        </tbody>
      </table>
    </cbp-table>
    
    ${ selectable ? `
      <cbp-action-bar variant="inline" context="dark-inverts">
        <div slot="cbp-action-bar-info">0 items selected.</div>
        <cbp-button fill="ghost" color="danger" context="dark-inverts" accessibility-text="Delete selected items">Delete</cbp-button>
        <cbp-button fill="ghost" context="dark-inverts" accessibility-text="Compare selected items">Compare</cbp-button>
      </cbp-action-bar>          
    ` : ''}
  `;
};

export const BasicTable = Template.bind({});
BasicTable.args = {
  striped: 'even',
  headers: [
    {
      label: "Header 1",
      sortable: true,
    },
    {
      label: "Header 2",
      sortable: true,
    },
    {
      label: "Header 3 is longer",
      sortable: true,
    },
    {
      label: "Header 4",
      sortable: true,
    },
    {
      label: "Header 5",
      sortable: false,
    },
  ],
  tableData: [
    {
      row: [
        {td: 'Row 1 Column 1 Cell Text'},
        {td: 'Row 1 Column 2 Cell Text'},
        {td: 'Row 1 Column 3 Cell Text'},
        {td: 'Row 1 Column 4 Cell Text'},
        {td: 'Row 1 Column 4 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 2 Column 1 Cell Text'},
        {td: 'Row 2 Column 2 Cell Text'},
        {td: 'Row 2 Column 3 Cell Text'},
        {td: 'Row 2 Column 4 Cell Text'},
        {td: 'Row 2 Column 5 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 3 Column 1 Cell Text'},
        {td: 'Row 3 Column 2 Cell Text'},
        {td: 'Row 3 Column 3 Cell Text'},
        {td: 'Row 3 Column 4 Cell Text is longer than the rest'},
        {td: 'Row 3 Column 5 Cell Text'},      ]
    },
    {
      row: [
        {td: 'Row 4 Column 1 Cell Text'},
        {td: 'Row 4 Column 2 Cell Text'},
        {td: 'Row 4 Column 3 Cell Text'},
        {td: 'Row 4 Column 4 Cell Text'},
        {td: 'Row 4 Column 5 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 5 Column 1 Cell Text'},
        {td: 'Row 5 Column 2 Cell Text'},
        {td: 'Row 5 Column 3 Cell Text'},
        {td: 'Row 5 Column 4 Cell Text'},
        {td: 'Row 5 Column 5 Cell Text'},
      ]
    },
  ]
}


export const dangerTable = Template.bind({});
dangerTable.args = {
  striped: 'even',
  headers: [
    {
      label: "Header 1",
      sortable: true,
    },
    {
      label: "Header 2",
      sortable: true,
    },
    {
      label: "Header 3 is longer",
      sortable: true,
    },
    {
      label: "Header 4",
      sortable: true,
    },
    {
      label: "Header 5",
      sortable: false,
    },
  ],
  tableData: [
    {
      row: [
        {td: 'Row 1 Column 1 Cell Text'},
        {td: 'Row 1 Column 2 Cell Text'},
        {td: 'Row 1 Column 3 Cell Text'},
        {td: 'Row 1 Column 4 Cell Text'},
        {td: 'Row 1 Column 4 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 2 Column 1 Cell Text'},
        {td: 'Row 2 Column 2 Cell Text', danger: true},
        {td: 'Row 2 Column 3 Cell Text'},
        {td: 'Row 2 Column 4 Cell Text', danger: true},
        {td: 'Row 2 Column 5 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 3 Column 1 Cell Text'},
        {td: 'Row 3 Column 2 Cell Text'},
        {td: 'Row 3 Column 3 Cell Text'},
        {td: 'Row 3 Column 4 Cell Text is longer than the rest'},
        {td: 'Row 3 Column 5 Cell Text'},
      ], danger: true
    },
    {
      row: [
        {td: 'Row 4 Column 1 Cell Text'},
        {td: 'Row 4 Column 2 Cell Text'},
        {td: 'Row 4 Column 3 Cell Text'},
        {td: 'Row 4 Column 4 Cell Text'},
        {td: 'Row 4 Column 5 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 5 Column 1 Cell Text'},
        {td: 'Row 5 Column 2 Cell Text'},
        {td: 'Row 5 Column 3 Cell Text'},
        {td: 'Row 5 Column 4 Cell Text'},
        {td: 'Row 5 Column 5 Cell Text'},
      ]
    },
  ]
}


export const highlightTable = Template.bind({});
highlightTable.args = {
  striped: 'even',
  headers: [
    {
      label: "Header 1",
      sortable: true,
    },
    {
      label: "Header 2",
      sortable: true,
    },
    {
      label: "Header 3 is longer",
      sortable: true,
    },
    {
      label: "Header 4",
      sortable: true,
    },
    {
      label: "Header 5",
      sortable: false,
    },
  ],
  tableData: [
    {
      row: [
        {td: 'Row 1 Column 1 Cell Text'},
        {td: 'Row 1 Column 2 Cell Text'},
        {td: 'Row 1 Column 3 Cell Text'},
        {td: 'Row 1 Column 4 Cell Text'},
        {td: 'Row 1 Column 4 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 2 Column 1 Cell Text', highlight: true},
        {td: 'Row 2 Column 2 Cell Text'},
        {td: 'Row 2 Column 3 Cell Text', highlight: true},
        {td: 'Row 2 Column 4 Cell Text'},
        {td: 'Row 2 Column 5 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 3 Column 1 Cell Text'},
        {td: 'Row 3 Column 2 Cell Text', highlight: true},
        {td: 'Row 3 Column 3 Cell Text'},
        {td: 'Row 3 Column 4 Cell Text is longer than the rest'},
        {td: 'Row 3 Column 5 Cell Text'},      ]
    },
    {
      row: [
        {td: 'Row 4 Column 1 Cell Text'},
        {td: 'Row 4 Column 2 Cell Text'},
        {td: 'Row 4 Column 3 Cell Text'},
        {td: 'Row 4 Column 4 Cell Text'},
        {td: 'Row 4 Column 5 Cell Text'},
      ]
    },
    {
      row: [
        {td: 'Row 5 Column 1 Cell Text'},
        {td: 'Row 5 Column 2 Cell Text'},
        {td: 'Row 5 Column 3 Cell Text'},
        {td: 'Row 5 Column 4 Cell Text'},
        {td: 'Row 5 Column 5 Cell Text'},
      ]
    },
  ]
}


export const singleRowActionTable = Template.bind({});
singleRowActionTable.args = {
  striped: 'even',
  headers: [
    {
      label: "Header 1",
      sortable: true,
    },
    {
      label: "Header 2",
      sortable: true,
    },
    {
      label: "Header 3 is longer",
      sortable: true,
    },
    {
      label: "Actions",
      sortable: false,
      alignmentRight: true
    },
  ],
  tableData: [
    {
      row: [
        {td: 'Row 1 Column 1 Cell Text'},
        {td: 'Row 1 Column 2 Cell Text'},
        {td: 'Row 1 Column 3 Cell Text'},
        {td: `  <cbp-button
                  fill="outline"
                  color="secondary"
                  accessibility-text="View details of Row 1"
                > 
                  View 
                </cbp-button>`,
          alignmentRight: true
        },
      ]
    },
    {
      row: [
        {td: 'Row 2 Column 1 Cell Text'},
        {td: 'Row 2 Column 2 Cell Text'},
        {td: 'Row 2 Column 3 Cell Text'},
        {td: `  <cbp-button
                  fill="outline"
                  color="secondary"
                  accessibility-text="View details of Row 2"
                > 
                  View
                </cbp-button>`,
          alignmentRight: true
        },
      ]
    },
    {
      row: [
        {td: 'Row 3 Column 1 Cell Text'},
        {td: 'Row 3 Column 2 Cell Text'},
        {td: 'Row 3 Column 3 Cell Text'},
        {td: `  <cbp-button
                  fill="outline"
                  color="secondary"
                  accessibility-text="View details of Row 3"
                > 
                  View
                </cbp-button>`,
          alignmentRight: true
        },
      ]
    },
    {
      row: [
        {td: 'Row 4 Column 1 Cell Text'},
        {td: 'Row 4 Column 2 Cell Text'},
        {td: 'Row 4 Column 3 Cell Text'},
        {td: `  <cbp-button
                  fill="outline"
                  color="secondary"
                  accessibility-text="View details of Row 4"
                > 
                  View
                </cbp-button>`,
          alignmentRight: true
        },
      ]
    },
    {
      row: [
        {td: 'Row 5 Column 1 Cell Text'},
        {td: 'Row 5 Column 2 Cell Text'},
        {td: 'Row 5 Column 3 Cell Text'},
        {td: `  <cbp-button
                  fill="outline"
                  color="secondary"
                  accessibility-text="View details of Row 5"
                > 
                  View
                </cbp-button>`,
          alignmentRight: true
        },
      ]
    },
  ]
}


export const OverflowMenu = Template.bind({});
OverflowMenu.storyName = "Single Action Table with Overflow Menu"
OverflowMenu.args = {
  striped: 'even',
  headers: [
    {
      label: "Header 1",
      sortable: true,
    },
    {
      label: "Header 2",
      sortable: true,
    },
    {
      label: "Header 3 is longer",
      sortable: true,
    },
    {
      label: "Actions",
      sortable: false,
      alignmentRight: true
    },
  ],
  tableData: [
    {
      row: [
        {td: 'Row 1 Column 1 Cell Text'},
        {td: 'Row 1 Column 2 Cell Text'},
        {td: 'Row 1 Column 3 Cell Text'},
        {td: `
          <cbp-menu
            uid="menuId1"
            position="bottom-end"
          >

            <cbp-button
              fill="outline"
              color="secondary"
              variant="square"
              accessibility-text="Actions"
              target-prop="open"
              controls="menuId1"
            >
              <cbp-icon name="ellipsis-vertical"></cbp-icon>
            </cbp-button>

            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="eye"></cbp-icon>
                View
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="pen-to-square"></cbp-icon>
                Edit
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item color="danger">
              <cbp-button fill="ghost" color="danger">   
                <cbp-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                </cbp-icon>
                Delete
              </cbp-button>
            </cbp-menu-item>
          </cbp-menu>`,
          alignmentRight: true
        }
      ]
    },
    {
      row: [
        {td: 'Row 2 Column 1 Cell Text'},
        {td: 'Row 2 Column 2 Cell Text'},
        {td: 'Row 2 Column 3 Cell Text'},
        {td: `
          <cbp-menu
            uid="menuId2"
            position="bottom-end"
          >

            <cbp-button
              fill="outline"
              color="secondary"
              variant="square"
              accessibility-text="Actions"
              target-prop="open"
              controls="menuId2"
            >
              <cbp-icon name="ellipsis-vertical"></cbp-icon>
            </cbp-button>

            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="eye"></cbp-icon>
                View
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="pen-to-square"></cbp-icon>
                Edit
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item color="danger">
              <cbp-button fill="ghost" color="danger">   
                <cbp-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                </cbp-icon>
                Delete
              </cbp-button>
            </cbp-menu-item>
          </cbp-menu>`,
          alignmentRight: true
        }
      ]
    },
    {
      row: [
        {td: 'Row 3 Column 1 Cell Text'},
        {td: 'Row 3 Column 2 Cell Text'},
        {td: 'Row 3 Column 3 Cell Text'},
        {td: `
          <cbp-menu
            uid="menuId3"
            position="bottom-end"
          >

            <cbp-button
              fill="outline"
              color="secondary"
              variant="square"
              accessibility-text="Actions"
              target-prop="open"
              controls="menuId3"
            >
              <cbp-icon name="ellipsis-vertical"></cbp-icon>
            </cbp-button>

            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="eye"></cbp-icon>
                View
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="pen-to-square"></cbp-icon>
                Edit
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item color="danger">
              <cbp-button fill="ghost" color="danger">   
                <cbp-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                </cbp-icon>
                Delete
              </cbp-button>
            </cbp-menu-item>
          </cbp-menu>`,
        alignmentRight: true
        }
      ]
    },
    {
      row: [
        {td: 'Row 4 Column 1 Cell Text'},
        {td: 'Row 4 Column 2 Cell Text'},
        {td: 'Row 4 Column 3 Cell Text'},
        {td: `
          <cbp-menu
            uid="menuId4"
            position="bottom-end"
          >

            <cbp-button
              fill="outline"
              color="secondary"
              variant="square"
              accessibility-text="Actions"
              target-prop="open"
              controls="menuId4"
            >
              <cbp-icon name="ellipsis-vertical"></cbp-icon>
            </cbp-button>

            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="eye"></cbp-icon>
                View
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="pen-to-square"></cbp-icon>
                Edit
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item color="danger">
              <cbp-button fill="ghost" color="danger">   
                <cbp-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                </cbp-icon>
                Delete
              </cbp-button>
            </cbp-menu-item>
          </cbp-menu>`,
          alignmentRight: true
        }
      ]
    },
    {
      row: [
        {td: 'Row 5 Column 1 Cell Text'},
        {td: 'Row 5 Column 2 Cell Text'},
        {td: 'Row 5 Column 3 Cell Text'},
       {td: `
          <cbp-menu
            uid="menuId5"
            position="bottom-end"
          >

            <cbp-button
              fill="outline"
              color="secondary"
              variant="square"
              accessibility-text="Actions"
              target-prop="open"
              controls="menuId5"
            >
              <cbp-icon name="ellipsis-vertical"></cbp-icon>
            </cbp-button>

            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="eye"></cbp-icon>
                View
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item>
              <cbp-button> 
                <cbp-icon name="pen-to-square"></cbp-icon>
                Edit
              </cbp-button>
            </cbp-menu-item>
            <cbp-menu-item color="danger">
              <cbp-button fill="ghost" color="danger">   
                <cbp-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                </cbp-icon>
                Delete
              </cbp-button>
            </cbp-menu-item>
          </cbp-menu>`,
          alignmentRight: true
        }
      ]
    },
  ]
}